import {
  Box,
  FormControl,
  FormLabel,
  IconButton,
  Input,
  Heading,
  HStack,
  SimpleGrid,
} from "@chakra-ui/react";
import { HiOutlinePlus, HiOutlineTrash } from "react-icons/hi";
import CodesetSelect from "../../CodesetSelect";
import UuidPreview from "../../UuidPreview";
import CurrencyAmountInput from "../../CurrencyAmountInput";
import RateAmountInput from "../../RateAmountInput";
import PartySelectById from "../../PartySelectById";
import LocationsEditor from "../../LocationsEditor";
import { createEmptyTax } from "../../utils/placementDefaults";

const TaxEditor = ({ tax, taxIndex, onUpdate, onRemove }) => {
  const updateField = (field, value) => {
    onUpdate(taxIndex, field, value);
  };

  return (
    <Box borderWidth="1px" borderRadius="md" p={4} mb={6} borderColor="gray.500">
      <UuidPreview uuid={tax.id} />

      <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4} mb={4}>
        <FormControl>
          <FormLabel>Description</FormLabel>
          <Input
            value={tax.description || ""}
            onChange={(e) => updateField("description", e.target.value)}
          />
        </FormControl>

        <CodesetSelect
          label="Type"
          codesetCode="A82"
          value={tax.type ? { code: tax.type, description: "" } : null}
          onChange={(value) => updateField("type", value.code)}
        />

        <CodesetSelect
          label="Application Type"
          codesetCode="A83"
          value={tax.applicationType ? { code: tax.applicationType, description: "" } : null}
          onChange={(value) => updateField("applicationType", value.code)}
        />
      </SimpleGrid>

      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4} mb={4}>
        <CurrencyAmountInput
          label="Base Amount"
          value={tax.baseAmount}
          onChange={(value) => updateField("baseAmount", value)}
        />

        <RateAmountInput
          label="Rate"
          value={tax.rate}
          onChange={(value) => updateField("rate", value)}
        />

        <CurrencyAmountInput
          label="Amount"
          value={tax.amount}
          onChange={(value) => updateField("amount", value)}
        />

        <FormControl>
          <FormLabel>Unit Count</FormLabel>
          <Input
            type="number"
            value={tax.unitCount}
            onChange={(e) => updateField("unitCount", parseInt(e.target.value) || 0)}
          />
        </FormControl>
      </SimpleGrid>

      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4} mb={4}>
        <PartySelectById
          label="Payable By Party"
          value={tax.payableByParty}
          onChange={(value) => updateField("payableByParty", value)}
        />

        <PartySelectById
          label="Administrator Party"
          value={tax.administratorParty}
          onChange={(value) => updateField("administratorParty", value)}
        />
      </SimpleGrid>

      <LocationsEditor
        filter="#Tax"
        locations={tax.locations || []}
        onChange={(locations) => updateField("locations", locations)}
      />

      <HStack justify="flex-end" mt={4}>
        <IconButton
          size="md"
          icon={<HiOutlineTrash />}
          aria-label="Delete Tax"
          onClick={() => onRemove(taxIndex)}
        />
      </HStack>
    </Box>
  );
};

const TaxesEditor = ({ taxes = [], onChange }) => {
  const updateTax = (taxIndex, field, value) => {
    const updated = [...taxes];
    updated[taxIndex] = {
      ...updated[taxIndex],
      [field]: value,
    };
    onChange(updated);
  };

  const addTax = () => {
    onChange([...taxes, createEmptyTax()]);
  };

  const removeTax = (taxIndex) => {
    const updated = [...taxes];
    updated.splice(taxIndex, 1);
    onChange(updated);
  };

  return (
    <Box>
      <HStack alignItems="center" mb={4}>
        <Heading size="md">Taxes</Heading>
        <IconButton
          icon={<HiOutlinePlus />}
          size="md"
          aria-label="Add Tax"
          onClick={addTax}
        />
      </HStack>

      {taxes.map((tax, taxIndex) => (
        <TaxEditor
          key={tax.id}
          tax={tax}
          taxIndex={taxIndex}
          onUpdate={updateTax}
          onRemove={removeTax}
        />
      ))}
    </Box>
  );
};

export default TaxesEditor;
